// shell-sdk/src/store.js

const STORE_EVENT = "shell:storeChanged";

function ensureStore() {
    window.__shellStore = window.__shellStore || {};
    return window.__shellStore;
}

export function getStoreValue(key) {
    return ensureStore()[key] ?? null;
}

export function setStoreValue(key, value) {
    ensureStore()[key] = value;

    window.dispatchEvent(
        new CustomEvent(STORE_EVENT, { detail: { key, value } })
    );
}

export function removeStoreValue(key) {
    delete ensureStore()[key];

    window.dispatchEvent(
        new CustomEvent(STORE_EVENT, { detail: { key, value: null } })
    );
}

export function subscribeStore(key, cb) {
    const handler = (event) => {
        if (event.detail?.key === key) {
            cb(event.detail.value ?? null);
        }
    };

    window.addEventListener(STORE_EVENT, handler);
    return () => window.removeEventListener(STORE_EVENT, handler);
}
